import React, { useState } from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { CorperateInfoStyled } from "./styled";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  setReduxAuthenOrganizationPhoneNumber,
  setReduxAuthenOrganizationEmail,
  setReduxAuthenOrganizationProvince,
} from "store/reducers/authenReducer";
import { userService } from "apiServices";
import { toast } from "react-toastify";
import { Buttons, Displays, Forms, Modals } from "components";

const CorperateInfo = ({
  theme_standard,
  coporate_id,
  phone_number,
  province,
  email,
  name,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const dispatch = useDispatch();
  const { t } = useTranslation(["profile", "register", "common"]);

  const [isShowModal, setIsShowModal] = useState(false);
  const [isBgLoading, setIsBgLoading] = useState(false);

  const handleOpenModal = () => {
    setIsShowModal(true);
  };

  const handleCloseModal = () => {
    setIsBgLoading(false);
    setIsShowModal(false);
  };

  const handleSubmit = async (values) => {
    setIsBgLoading(true);
    let params = {
      ...values,
    };
    if (values.province) {
      params.province = values.province.value;
    }
    let res = await userService.PUT_MY_ORGANIZE_UPDATE_DETAIL(params);
    if (res && res.status === 200) {
      dispatch(setReduxAuthenOrganizationPhoneNumber(res.data.phone_number));
      dispatch(setReduxAuthenOrganizationEmail(res.data.email));
      dispatch(setReduxAuthenOrganizationProvince(res.data.province));
      handleCloseModal();
      toast.success(t("Update success", { ns: "common" }));
    } else {
      handleCloseModal();
      toast.error(t("Update failed", { ns: "common" }));
    }
  };

  return (
    <>
      <Displays.BGLoading visible={isBgLoading} />
      <CorperateInfoStyled>
        <div className={customClass}>
          <div className="user_info_container">
            <div className="title">{t("My Profile", { ns: "common" })}</div>
            <div className="ui_row">
              <div className="ui_label">
                {t("Organization Name", { ns: "register" })}
              </div>
              <div className="ui_value">
                <span className="ui_text">{`${name}`}</span>
              </div>
            </div>
            <div className="ui_row">
              <div className="ui_label">{t("Tax ID", { ns: "register" })}</div>
              <div className="ui_value">
                <span className="ui_text">{coporate_id || "-"}</span>
              </div>
            </div>
            <div className="ui_row">
              <div className="ui_label">
                {t("Mobile number", { ns: "register" })}
              </div>
              <div className="ui_value">
                <span className="ui_text">{phone_number}</span>
              </div>
            </div>
            <div className="ui_row">
              <div className="ui_label">{t("Email", { ns: "register" })}</div>
              <div className="ui_value">
                <span className="ui_text">{email}</span>
              </div>
            </div>
            <div className="ui_row">
              <div className="ui_label">{t("Address", { ns: "profile" })}</div>
              <div className="ui_value">
                <span className="ui_text">{province}</span>
              </div>
            </div>
          </div>
          <div className="btn_edit_organization_data">
            <Buttons.BgStandard
              theme_white_purple
              label={t("Edit", { ns: "common" })}
              height="30px"
              onClick={handleOpenModal}
            />
          </div>
        </div>
      </CorperateInfoStyled>
      <Modals.BodyEmpty
        isShowModal={isShowModal}
        onCloseModal={handleCloseModal}
      >
        <Forms.OrganizationEditForm
          onSubmit={handleSubmit}
          initialValues={{ phone_number, email, province }}
        />
      </Modals.BodyEmpty>
    </>
  );
};

CorperateInfo.propTypes = {};

export default CorperateInfo;
